<template>
    <div>

        <div class="container">

            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" sortable width="65"></el-table-column>
                <el-table-column label="关键字名称" prop="Tname" sortable width="220"></el-table-column>
                <el-table-column label="拼音码" prop="Tchar" sortable></el-table-column>
                <el-table-column label="Logo图片" prop="Tlogo" sortable width="420">
                    <template slot-scope="scope">
                        <el-link @click="openImg('http://yp.img.lvyoujisan.com/'+scope.row.Tlogo)">http://yp.img.lvyoujisan.com/{{scope.row.Tlogo}}</el-link>
                    </template>
                </el-table-column>

                <el-table-column :filter-method="filterTag"
                                 :filters="[{ text: '景点', value: '1' }, { text: '酒店', value: '2' }, { text: '线路', value: '3' }, { text: '用户城市', value: '4' }]"
                                 align="center"
                                 label="类别"
                                 prop="Ttype">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Ttype===1?'success':(scope.row.Ttype===2?'info':(scope.row.Ttype===3?'warning':'danger'))"
                        >{{scope.row.Ttype===1?'景点':(scope.row.Ttype===2?'酒店':(scope.row.Ttype===3?'线路':'用户城市'))}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="排序编号" prop="Torderid"></el-table-column>
                <el-table-column :filter-method="filterTag"
                                 :filters="[{ text: '屏蔽中', value: '0' }, { text: '正显示', value: '1' },
                                  { text: '首页-1', value: '2' }, { text: '首页-2', value: '3' }, { text: '首页-3', value: '4' }]"
                                 align="center"
                                 label="所属状态"
                                 prop="Tstate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Tstate===0?'danger':(scope.row.Tstate===1?'success':'info')"
                        >{{scope.row.Tstate===0?'屏蔽中':(scope.row.Tstate===1?'正显示':(scope.row.Tstate===2?'首页-1':
                            (scope.row.Tstate===3?'首页-2':(scope.row.Tstate===4?'首页-3':'首页-4'))))}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :visible.sync="editVisible" title="编辑关键字信息" width="30%">
            <el-form :model="form" ref="form">
                <el-form-item label="当前名称">
                    <el-input class="wd200" v-model="form.Tname"></el-input>
                </el-form-item>
                <el-form-item label="拼音编码">
                    <el-input class="wd200" v-model="form.Tchar"></el-input>
                </el-form-item>
                <el-form-item label="排序编号">
                    <el-input class="wd200" v-model="form.Torderid"></el-input>
                </el-form-item>
                <el-form-item label="所属状态">
                    <el-select placeholder="请选择" v-model="form.Tstate">
                        <el-option :value="0" label="屏蔽中"></el-option>
                        <el-option :value="1" label="正显示"></el-option>
                        <el-option :value="2" label="首页-1"></el-option>
                        <el-option :value="3" label="首页-2"></el-option>
                        <el-option :value="4" label="首页-3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属类别">
                    <el-select placeholder="请选择" v-model="form.Ttype">
                        <el-option :value="1" label="景点"></el-option>
                        <el-option :value="2" label="酒店"></el-option>
                        <el-option :value="3" label="线路"></el-option>
                        <el-option :value="4" label="用户城市"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="更改LOGO">
                    <el-upload
                            :before-remove="beforeRemove"
                            :before-upload="beforeAvatarUpload"
                            :http-request="uploadTagsLogo"
                            :show-file-list="false"
                            action=""
                            list-type="picture">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                fileList: [],
                query: {
                    pageIndex: 1,
                    pageSize: 10
                },
                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                multipleSelection: [],
                editVisible: false,
                addVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1
            };
        },
        created() {
            // this.reload();
            this.getKeywordsData();
        },
        methods: {
            async getKeywordsData() {
                const { data: res } = await this.$http.post('admin/common/pageKeywords', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取关键字列表失败，请联系管理员!');
                }
                this.tableData = res.list;
                this.pageTotal = res.pageTotal || 25;

                this.$message.success('【关键字列表】加载成功!');
            },
            // 打开网址对应的图片
            openImg(url) {
                window.open(url, '_blank');

            },
            //上传文件
            async uploadTagsLogo(param) {
                const formData = new FormData();
                formData.append('file', param.file);
                formData.append('id', this.form.Id);
                const { data: res } = await this.$http.post('/admin/common/updateKeywordsLogo', formData);
                if (res.code !== 200) {
                    return this.$message.error('系统错误，更新Tags-LOGO数据失败，请联系管理员!');
                }
                this.form.Tlogo=res.url;
                this.$message.success('【Tags-LOGO】上传成功!');
            },

            //上传前的检查判断
            beforeAvatarUpload(file) {
                const isJPG =
                    file.type === 'image/gif' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/jpeg' ||
                    file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('仅支持gif,jpg,png格式的图片！');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!' + isLt2M);
                }
                return isJPG && isLt2M;
            },
            // 删除当前图片前的确认
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            // 删除当前图片
            async handleRemove(file, fileList) {
                const { data: res } = await this.$http.post('/admin/scenics/updateImages', {
                    id: file.id
                });
            },
            handlePictureCardPreview(file) {
                this.picture_ImageUrl = file.url;
                this.picture_Visible = true;
            },

            //限制上传文件的数量
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },


            // 编辑操作
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
            },

            // 保存编辑
            async saveEdit() {
                this.editVisible = false;
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/common/updateKeywords', {
                    form: this.form
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
                //  this.form=[];
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getKeywordsData();
            },
            //标签筛选
            filterTag(value, row) {
                console.log('is runing' + value);
                return row.Sstate == value;
            }
        }

    };
</script>

<style scoped>

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
